import axios from "axios";
import { toast } from "react-toastify";
import { config } from "../alerts/index";

export const useStore = () => ({
  subscribe: async (payload) => {
    const link = import.meta.env.PUBLIC_LIVE_LINK;
    // const link = "https://liv-app-integration.vercel.app"
    // const link = "http://localhost:8080"
    try {
      await axios.post(`${link}/subscribe`,payload);
      // to fix later
      // const response2 = await axios.post(`${link}/subscribe`, payload);

      toast("Email Subscribed", { ...config, type: "success" });
    } catch (error) {
      toast("Subscription failed to send, Please try again.", {
        ...config,
        type: "error",
      });
      console.log("Subscription failed to send", error);
      return error.message;
    }
  },
});
